<template>
	<div class="app__default" key="default">
		<Header />
		<!-- Loader -->
		<!--<div id="preloader">
      <div id="status">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
    </div>-->
		<!-- Loader -->
		<slot />
		<Footer />
	</div>
</template>
<script>
import Header from "@/layout/partials/Header.vue";
import Footer from "@/layout/partials/Footer.vue";
export default {
	name: "Default-Layout",
	components: {
		Header,
		Footer,
	},
	data() {
		return {};
	},
};
</script>
